module.exports = __webpack_public_path__ + "static/media/visible_password.9c39d30a.svg";